// Converts a Date object to a string in the format YYYY-MM-DD
export const dateToString = (date: Date = new Date()): string => {
  const year = date.getFullYear()
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const day = date.getDate().toString().padStart(2, '0')

  return `${year}-${month}-${day}`
}

// Converts a string in the format YYYY-MM-DD to a Date object
export const stringToDate = (dateStr: string): Date | undefined => {
  const regex = /^\d{4}-\d{2}-\d{2}$/

  if (!regex.test(dateStr)) return undefined // Invalid format
  const [year, month, day] = dateStr.split('-').map(Number)

  return new Date(year, month - 1, day)
}

export const isSameDate = (
  date1: Date | undefined,
  date2: Date | undefined,
): boolean => {
  return (
    !!date1 &&
    !!date2 &&
    date1.getDate() === date2.getDate() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getFullYear() === date2.getFullYear()
  )
}
